var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"id":"inicis_form","name":"inicis_form","method":"post","action":"#"}}),_c('v-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }